var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07304 2.60417C8.07304 2.1727 7.72326 1.82292 7.29179 1.82292C6.86032 1.82292 6.51054 2.1727 6.51054 2.60417V4.24923C5.01123 4.36928 4.02696 4.66393 3.30384 5.38705C2.58071 6.11018 2.28607 7.09445 2.16602 8.59375H22.8342C22.7142 7.09445 22.4195 6.11018 21.6964 5.38705C20.9732 4.66393 19.989 4.36928 18.4897 4.24923V2.60417C18.4897 2.1727 18.1399 1.82292 17.7085 1.82292C17.277 1.82292 16.9272 2.1727 16.9272 2.60417V4.18011C16.2342 4.16667 15.4574 4.16667 14.5835 4.16667H10.4168C9.5428 4.16667 8.76603 4.16667 8.07304 4.18011V2.60417Z",
    fill: "#52447D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9166 12.5V14.5833C22.9166 18.5117 22.9166 20.4759 21.6962 21.6962C20.4759 22.9167 18.5116 22.9167 14.5833 22.9167H10.4166C6.48821 22.9167 4.52403 22.9167 3.30364 21.6962C2.08325 20.4759 2.08325 18.5117 2.08325 14.5833V12.5C2.08325 11.626 2.08325 10.8493 2.09669 10.1562H22.9031C22.9166 10.8493 22.9166 11.626 22.9166 12.5ZM17.1874 18.75C18.0503 18.75 18.7499 18.0504 18.7499 17.1875C18.7499 16.3246 18.0503 15.625 17.1874 15.625C16.3245 15.625 15.6249 16.3246 15.6249 17.1875C15.6249 18.0504 16.3245 18.75 17.1874 18.75Z",
    fill: "#52447D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMark);
export default __webpack_public_path__ + "static/media/calendar-mark.fee6eb21fabd3b46da277051a430944a.svg";
export { ForwardRef as ReactComponent };